import { Component, OnInit } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import { faSave, faBroom } from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "angular-notifier";
import { AccountAdjustmentService } from "src/app/services/autopac/account-adjustment.service";

@Component({
  selector: "app-account-adjustment",
  templateUrl: "./account-adjustment.component.html",
  styleUrls: ["./account-adjustment.component.css"],
})
export class AccountAdjustmentComponent implements OnInit {
  faSave = faSave;
  faBroom = faBroom;

  lockUpdate = true;

  form: FormField[] = [
    {
      type: "search",
      id: "ContractNo",
      label: "Contract number",
      required: true,
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "BuyerName",
      label: "Buyer name",
      lock: true,
    },
    {
      type: "text",
      id: "InvoiceNo",
      label: "Invoice number",
      lock: true,
    },
    {
      type: "number",
      id: "BalanceAmount",
      label: "Balance amount ($)",
      lock: true,
    },
    {
      type: "number",
      id: "AdjustmentAmount",
      label: "Adjustment amount ($)",
      required: true,
    },
    {
      type: "number",
      id: "AfterAdjustment",
      label: "Amount after adjustment ($)",
      lock: true,
    },
    {
      type: "select",
      id: "Category",
      label: "Category",
      options: [
        {
          display: "COE Rebate",
          value: "COE Rebate",
        },
        {
          display: "Interco",
          value: "Interco",
        },
        {
          display: "OPC less than $17k",
          value: "OPC less than $17k",
        },
        {
          display: "Own COE",
          value: "Own COE",
        },
        {
          display: "Miscellaneous",
          value: "Miscellaneous",
        },
        {
          display: "Number Retention",
          value: "Number Retention",
        },
        {
          display: "Used Car Settlement",
          value: "Used Car Settlement",
        },
        {
          display: "Excess Payment Write Off",
          value: "Excess Payment Write Off",
        },
        {
          display: "Excess Pay For Bank Charges",
          value: "Excess Pay For Bank Charges",
        },
      ],
    },
    {
      type: "text",
      id: "Remarks",
      label: "Reason for adjustment",
    },
  ];

  updateFields(event: any): void {
    this.form = event.fields;

    if (event.updatedValue == 4) {
      this.getField("AfterAdjustment").value =
        this.getNumber("BalanceAmount") +
        this.getNumber("AdjustmentAmount");
    }
  }

  constructor(
    private AccountAdjustmentService: AccountAdjustmentService,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {}

  fetchContractDetails(): void {
    this.lockUpdate = false;
    const ContractNo = this.getField("ContractNo").value || "";
    if (!ContractNo) {
      this.notifier.notify(
        "error",
        "Please enter a contract number.",
      );
      this.lockUpdate = true;
      return;
    }

    this.AccountAdjustmentService.getDetails(ContractNo).subscribe({
      next: (response) => {
        if (response.statusCode == 500) {
          console.log(response);
          this.notifier.notify("error", response.message);
          this.clear();
          this.lockUpdate = true;
        } else {
          const data = response?.body;
          if (data) {
            this.getField("AdjustmentAmount").value =
              data.AdjustmentAmount;
            this.getField("BalanceAmount").value = data.BalanceAmount;
            this.getField("BuyerName").value = data.BuyerName;
            this.getField("Category").value =
              data.Category || undefined;
            this.getField("InvoiceNo").value = data.InvoiceNo;
            this.getField("Remarks").value = data.Remarks;
          }
        }
      },
      error: (error) => {
        console.error("Error fetching contract details:", error);
        this.notifier.notify(
          "error",
          "Please input a valid Contract Number",
        );
      },
    });
  }

  update() {
    const payload = {
      AdjustmentAmount: this.getNumber("AdjustmentAmount"),
      BalanceAmount: this.getNumber("BalanceAmount"),
      BuyerName: this.getField("BuyerName").value,
      Category: this.getField("Category").value || null,
      ContractNo: this.getField("ContractNo").value,
      InvoiceNo: this.getField("InvoiceNo").value || null,
      Remarks: this.getField("Remarks").value || null,
      __type: "KAPS.Model.Autopac.CrmAccountAdjustment",
    };
    if (!this.getField("ContractNo").value) {
      this.notifier.notify(
        "error",
        "Please input a valid Contract Number",
      );
    } else {
      this.AccountAdjustmentService.update(payload).subscribe({
        next: (response) => {
          const message =
            response?.body?.Message ?? "Updated successfully.";
          this.notifier.notify("success", message);
          this.clear();
        },
        error: (error) => {
          console.error(error);
          this.notifier.notify("error", "Error updating data");
        },
      });
    }
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  getNumber(id: string): number {
    return Number(this.getField(id).value) || 0;
  }

  clear() {
    this.form.forEach((item) => {
      item.value = undefined;
    });
  }
}
